import React from "react"
import analyticsPicture from "./../../assets/png/Analytics_FAKE.png"
import {connect} from "react-redux"

const mapStateToProps = state => {
    return {
        modules: state.DashboardReducer.modules
    }
}

const Analytics = (props) => {
    let ip_adress = null
    if (props.modules !== undefined) {
        props.modules.map(item => {
            if (item.name === "Analytics") {
                if (item.ip_adress !== null) {
                    return ip_adress = item.ip_adress
                }
            }
        })
    }
    if (ip_adress === null) {
        return (
            <>
            <img src={analyticsPicture}></img>
            <style>
                {"img{margin-top: 100px; width: 95%}"}
            </style>
            </>
        )
    } else {
        return (<iframe src={ip_adress} width="100%" height="100%" />)
    }
}

export default connect(mapStateToProps)(Analytics)